var _path, _path2, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_1279)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.117 28.8393C99.2713 37.7891 100.678 47.7699 99.1598 57.5193C97.6413 67.2688 93.2658 76.349 86.5865 83.6115C79.9072 90.8741 71.2242 95.9927 61.6356 98.3201C52.047 100.648 41.9836 100.079 32.7181 96.6869C23.4526 93.2946 15.4011 87.2308 9.58206 79.2623C3.763 71.2939 0.437693 61.7788 0.0267046 51.9203C-0.384284 42.0619 2.1375 32.303 7.27313 23.8779C12.4088 15.4527 19.9275 8.73983 28.8786 4.58811C40.8785 -0.977773 54.5978 -1.54972 67.0193 2.99806C79.4409 7.54583 89.5477 16.8409 95.117 28.8393Z",
    fill: "#0C67FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3538 62.1878V69.4763H36.1344V63.6822L51.0456 49.5903C52.3186 48.4756 53.4012 47.1605 54.2507 45.697C54.7723 44.6993 55.0487 43.5916 55.0569 42.4657C55.0962 41.7902 54.974 41.115 54.7004 40.4961C54.4269 39.8772 54.0098 39.3324 53.4838 38.9067C52.4351 38.0765 50.9058 37.6614 48.8958 37.6614C47.3132 37.6387 45.7457 37.9702 44.3077 38.6314C42.9352 39.2839 41.7561 40.2823 40.8863 41.5285L34.3647 37.3599C35.9343 35.0793 38.093 33.2671 40.6111 32.1164C43.46 30.7801 46.5751 30.1078 49.7216 30.1501C52.3044 30.0954 54.8706 30.5752 57.2592 31.5593C59.2674 32.3913 61.0022 33.7696 62.2667 35.5378C63.4862 37.3155 64.1145 39.4323 64.0626 41.5874C64.0794 43.6278 63.6311 45.6452 62.7517 47.4864C61.8778 49.3303 60.1649 51.4299 57.6131 53.7851L48.7254 62.1878H65.3538Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M78.6522 89.0214C57.4422 104.752 31.015 105.001 19.6629 89.631C8.3107 74.261 16.2218 49.0725 37.4383 33.3617C58.6548 17.6509 85.0689 17.3822 96.4276 32.7521C107.786 48.1221 99.8621 73.3171 78.6522 89.0214Z",
    fill: "url(#paint0_radial_125_1279)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.3203,
    y: -15.8157,
    width: 79.9633,
    height: 82.585,
    fill: "url(#pattern0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.51514,
    y: 61.5259,
    width: 74.7198,
    height: 58.3339,
    fill: "url(#pattern1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16.4253,
    y: -9.91675,
    width: 64.8882,
    height: 71.4426,
    fill: "url(#pattern2)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M14.2493 19.4795C13.8888 22.4421 21.0724 21.5245 30.2879 17.4215C39.5033 13.3184 47.2768 7.58992 47.6373 4.62734C47.9978 1.66477 40.8142 2.57583 31.5922 6.67886C22.3702 10.7819 14.6033 16.5104 14.2493 19.4795Z",
    fill: "url(#paint1_radial_125_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M46.7721 13.9936C42.9641 14.6491 40.2899 17.8607 40.7946 21.2034C41.2992 24.5462 44.7862 26.7025 48.5943 26.0537C52.4023 25.4048 55.07 22.1866 54.5653 18.8439C54.0606 15.5011 50.5737 13.3447 46.7721 13.9936Z",
    fill: "url(#paint2_radial_125_1279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_125_1279",
    transform: "scale(0.00819672 0.00793651)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_125_1279",
    transform: "scale(0.00877193 0.011236)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_125_1279",
    transform: "scale(0.010101 0.00917431)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_125_1279",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.2799 62.7215) rotate(53.4475) scale(34.5034 47.7872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9BA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#9B9BA3",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9B9BA3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_125_1279",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.078 10.4244) rotate(156.067) scale(18.2273 4.61053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_125_1279",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7414 15.156) rotate(-98.4711) scale(6.10137 6.98586)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_1279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_125_1279",
    width: 122,
    height: 126,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_125_1279",
    width: 114,
    height: 89,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHIAAABZCAYAAADitnCIAAAACXBIWXMAAAsSAAALEgHS3X78AAAEAklEQVR4Xu2c208TURCHv61UNDRKvOM1UTRK4pvxRf9+HzTRBxPjPfGKeIsQUKFofZid9Ox2C0TQnp38vqQ5wPbGfnvmzMxpWgwGA0T76Wx3B9EOJDIIEhkEiQyCRAZBIoMgkUGQyCBIZBAkMggSGQSJDIJEBkEigyCRQZDIIEhkECQyCBIZBIkMgkQGQSKDIJFBkMggSGQQJDIIEhkEiQyCRAZBIoMgkUGQyCBMbXeHzClqozOojeFpg8hxsgqgC+wvRz8+APrARjmOkxlKds4iCyz0TwHTVGVR/n4IOFGO/r9sAivAx3LsM0qT7FaLzVGkC+wCM8AR4BRDWS5zGjgJXCrH6fLv68AS8KIc16kyoCp7GZPZJLY1UnMT6QJ7wFHgPHAZuEpVVoG993RGdstjfaozcpNRIXXZa5jQj8A34Gd52wR+Nzw+O4qMvtWjAxzExFwErgDXMZHnqMqC3a2RqexlTOQS8Bx4D3wCFoGv5bE+mQvNRWSBCTkN3ABuAQvABWxmzjC6Rvrj0tHZbr2ry+5jQpeAz8Bb4DHwDHgNfCFzoTmF1mngDHATuI1J7GECO4zK2opxglM62Gv6WjiLrcU/sfC6gIl8SFXoKkOh2ZCLSA+Th4GzwFz5c5rc7DV12R0sKvSw1z7GcI12oU+Bl1hI/kFGMnMRCcMExkuNffw7iU0UVKV61uxJ1zzwCLgD3MPW0g0yCbM5ifSyYJ1htjipFmKBXUj1MuhoefwLlix9A341PcH/JheRnnwsA++w0NXDTuCkZEJVqJ+rBeAJtmaukknyM8mTVGcdk3gfeIBljmvYFT/pE+VCe1iYvYolRl7XTpzcZuQnTGTabpvj77PXvaSpCeHJ2KQvtGxEgoWoH9hMhGEb7RrN9WSanPwPBrVbVuQkEiyMuswNrEB/TLXDMwscoNpI30nd+LcMsIusj62Ji9gSsExz+28i5CYSTOZ3hifrDVbHec/1LFbjncTqvS7NrTpnp5KbukEe8tewTPUVVoLcxd5fvSE/MXJp0TVRMJr+zwHHsVbePCZzBhNab577c2wl2RnXn/WerF9M2TYFchbpuNApLKQewMLrCUzgDM3bWU3JSSo5ZdyOie+S1Puu2bXp2iDSSROcdJZ5a6+eScL4Pcs6TXuY3qBYAT6Q+U5Im0SmpOveVuGzS3O5kJIKq3+qwENu2m3K8oS1VWSdcQnNbtdIP5aOWRJF5FbsJmttDTmWH3tNqwXtlJx6rWIXSGQQJDIIEhkEiQyCRAZBIoMgkUGQyCBIZBAkMggSGQSJDIJEBkEigyCRQZDIIEhkECQyCBIZBIkMgkQGQSKDIJFBkMggSGQQJDIIEhkEiQyCRAZBIoMgkUH4A/cKIO8+9htIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_125_1279",
    width: 99,
    height: 109,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/Step2.a0e5dc70f2817e965ab32d604d42a2f3.svg";
export { ForwardRef as ReactComponent };